import { initializeApp } from 'firebase/app'
import { ref as dbRef, getDatabase, onValue } from 'firebase/database'

export const firebaseApp = initializeApp({
  apiKey: "AIzaSyBI45h6dUtOyElvtR5m7-fKLhiZYXA5yTU",
  authDomain: "viv0006-quizwhiz.firebaseapp.com",
  databaseURL: "https://viv0006-quizwhiz-default-rtdb.firebaseio.com"
})

// used for the firestore refs
export const db = getDatabase(firebaseApp)

export const loginsRef = dbRef(db, 'logins');
export const usersRef = dbRef(db, 'users');
export const roundsRef = dbRef(db, 'rounds');
export const unlockedRef = dbRef(db, 'gameUnlocked');
// export const passwordRef = dbRef(db, 'password');
// export const endTimeRef = dbRef(db, 'endTime');

// start listening to firebase connection after slight delay
  // alert users when they disconnect from the database, likely a result of connectivity issues at the venue
const connectionRef = dbRef(db, '.info/connected')

window.setTimeout(() => {
  onValue(connectionRef, (snapshot) => {
    if(snapshot.val() === true){
      if(window.quizWhizApp.showErrorModal){
        window.quizWhizApp.toggleErrorModal()
        window.quizWhizApp.updateErrorMessage('')
        window.quizWhizApp.toggleErrorModalLock(false)
        window.quizWhizApp.toggleLoggedInStatus(true)
      }
    }else{
      window.quizWhizApp.updateErrorMessage('Connection lost.  Please connect to the network before continuing.')
      window.quizWhizApp.toggleErrorModal()
      window.quizWhizApp.toggleErrorModalLock(true)
      window.quizWhizApp.toggleLoggedInStatus(false)
    }
  })
}, 5000)